import { SET_IS_OPEN_MODAL } from '../actionTypes';
import { loadAndWindModalActons } from '../reducer';

export default (isOpen) => loadAndWindModalActons[SET_IS_OPEN_MODAL](isOpen);
